import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { ICONS, THEME } from "@/data/site";
import { Reveal } from "./Reveal";

export const ServiceCard = ({ s, i = 0 }) => {
  const t = THEME[s.dept];
  const Icon = ICONS[s.icon];
  return (
    <Reveal delay={(i % 3) * 0.07} className="h-full">
      <Link to={`/services/${s.slug}`} data-testid={`service-card-${s.slug}`} className="card-lift group flex h-full flex-col overflow-hidden rounded-[26px] border border-line bg-white">
        <div className="relative h-44 overflow-hidden">
          <img src={s.image} alt={s.titleEn} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
          <span className={`absolute left-4 top-4 flex h-10 w-10 items-center justify-center rounded-xl text-white shadow-lg ${t.bg}`}><Icon className="h-5 w-5" /></span>
          {s.featured && <span className="font-en absolute right-4 top-4 rounded-full bg-white/90 px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wider text-ink">Popular</span>}
        </div>
        <div className="flex flex-1 flex-col p-6">
          <h3 className="text-xl font-bold leading-snug text-ink">{s.titleHi}</h3>
          <p className={`font-en mt-1 text-xs font-medium ${t.text}`}>{s.titleEn}</p>
          <p className="mt-3 text-[15px] leading-relaxed text-muted2">{s.summaryHi}</p>
          <span className={`mt-auto inline-flex items-center gap-1 pt-5 text-sm font-semibold ${t.text}`}>पूरी जानकारी <ArrowUpRight className="h-4 w-4 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" /></span>
        </div>
      </Link>
    </Reveal>
  );
};
